  function default_attribution(){
    var default_attr = {};
    // They are all in : https://advertising.amazon.com/attribution/campaigns/576880478548469873/attribution-tags?entityId=ENTITY2AQVTE4950NDM
    default_attr["blog"]      = "maas_adg_700D77964CB95BCF8CFC220A6BEB1BB7_afap_abs"; 
    default_attr["blog-epb"]      = "maas_adg_3514A857665478976C26EE0CE128B378_afap_abs";  // https://advertising.amazon.com/attribution/campaigns/578820088067313969/adgroups?entityId=ENTITY2AQVTE4950NDM
    default_attr["topcta"]    = "maas_adg_224C813FCB8DC8526F33BFFC50DFD2CD_afap_abs";  
    default_attr["cta_quiz_regular"] = "maas_adg_3C93CAD946D06914E7924F852084AA3D_afap_abs"; 
    default_attr["cta_shop_regular"] = "maas_adg_224C813FCB8DC8526F33BFFC50DFD2CD_afap_abs"; 
    default_attr["google_shopping"] = "maas_adg_8F563EABB62E48C1C643B7AB96FE144E_afap_abs";
    default_attr["shop"] = "maas_adg_4F5678E73EF03C0649ADCD65DA17ABB0_afap_abs"; // shop default
    default_attr["coverage_checker"] = "maas_adg_B77500C1A6D08819730EA20AC80E92FF_afap_abs";
    default_attr["rs2"] = "maas_adg_A69F9EDB0C0A503D868FBEE59EE93579_afap_abs";
    default_attr["tool-5610"] = "maas_adg_A981334ED1F754B2D2E960E33D8213A2_afap_abs";  
    default_attr["tool-5512"] = "maas_adg_A86956E47E3DFDB1EE447339C7A6E209_afap_abs";
    default_attr["tool-5510"] = "maas_adg_655916D78319D942471249987C2F22AD_afap_abs";
    default_attr["tool-5410"] = "maas_adg_34AC3B141E88E3F2B7A9CDA42EA31703_afap_abs";
    default_attr["tool-5310"] = "maas_adg_D85713BC918A039AB7B1C57C96667CAA_afap_abs";
    default_attr["tool-5210"] = "maas_adg_A0F9FB85C53023CCEBAD8982567475CC_afap_abs";
    default_attr["tool-5110"] = "maas_adg_E1170F0F141D2711F9101E18A163E731_afap_abs";
    default_attr["tool-1000"] = "maas_adg_05E0647EBC0B49B746851E1CAC429C25_afap_abs";
	return default_attr;
  }
  
  function amazon_tool_url(){
    var tool_urls = {};
    tool_urls["tool-5610"] = "https://www.amazon.com/5610-OBD2-Scanner-Bidirectional/dp/B07Z481NJM/?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-5512"] = "https://www.amazon.com/5512-OBD2-Scanner-abs-bleed-obd1/dp/B09WPW4WQ4?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-5510"] = "https://www.amazon.com/5510-OBD2-Scanner-abs-bleed/dp/B07Z48NKF1?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-5410"] = "https://www.amazon.com/5410-OBD2-Scanner-all-system-scaner/dp/B07ZL7CLYR?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-5310"] = "https://www.amazon.com/5310-OBD2-Scanner-abs-srs/dp/B07ZL746BR?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-5210"] = "https://www.amazon.com/5210-OBD2-Scanner-abs/dp/B07Z46L5FG?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-5110"] = "https://www.amazon.com/5110-OBD2-Scanner-code-reader/dp/B07Z46KNLR?m=A338X9NNA1JLZE&maas=";

    tool_urls["tool-3360"] = "https://www.amazon.com/INNOVA-3360-Infrared-Thermal-Camera/dp/B09WRQ3LFH?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-3380"] = "https://www.amazon.com/Innova-3380-Boroscope/dp/B082JCSB4Z?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-ds200"] = "https://www.amazon.com/INNOVA-DS200-High-Speed-Multimeter/dp/B0BYBLFFGM?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-5420"] = "https://www.amazon.come/Innova-Power-Check-Electrical-Tester/dp/B09ZQ3ZQV2?m=A338X9NNA1JLZE&maas=";
    tool_urls["tool-1000"] = "https://www.amazon.com/Innova-1000-OBD2-Scanner-Bluetooth/dp/B0D32BNNQ9?m=A338X9NNA1JLZE&maas=";

    tool_urls["tool-5160rs"] = "https://www.amazon.com/5160RS-Bidirectional-OE-Level-Diagnostics-Recommended/dp/B071VYLP32?maas=";
    tool_urls["tool-3160rs"] = "https://www.amazon.com/INNOVA-3160RS-Scanner-Service-Network/dp/B084SVSFZY?maas=";
    tool_urls["tool-3130rs"] = "/products/fixassist-3130rs?tag=";
    tool_urls["tool-3100rs"] = "https://www.amazon.com/Innova-3100RS-Scanner-Reader-Service/dp/B084SW4K8J?maas=";
    tool_urls["tool-3040rs"] = "https://www.amazon.com/INNOVA-3040RS-Scanner-Battery-Testing/dp/B084SVS383?maas=";
    tool_urls["tool-3020rs"] = "https://www.amazon.com/Innova-3020RS-Scanner-Reader-Emissions/dp/B084SWJL4J?maas=";
    tool_urls["tool-3215rs"] = "/products/fixassist-3215rs?tag=";
    
    tool_urls["shop"] = tool_urls["tool-5610"];
	return tool_urls;
  }

  function get_default_attr(key){
    return default_attribution()[key];
  }

  function get_tool_url(key){
    return amazon_tool_url()[key];
  }

  function affil_tag(){
    //return 'innova08-20';
    return '';
  }


  //////////////////////////////////////////////////////////////
  // This applies a 'priority' to tagging
  // By default - no paramters = default attribution
  // Then, local_override
  // Then, tag=attribution_tag 
  // Then, src=attribution_tag
  // Then highest priority, override=attribution_tag
  //////////////////////////////////////////////////////////////
  function attribute_urls(tool_pdp,attribute_tag='tag',local_override=null){
    var default_attr = default_attribution();    
    var tool_urls = amazon_tool_url();

    //Adds a tag param in url
    //Then ads this attribution tag to all amazon links in the doc that contain the class "amazon_link"
    //Format should be www.innova.com/pages/5610?tag=xxxx
    const urlParams = new URLSearchParams(window.location.search);
    var  attr_tag = urlParams.get(attribute_tag),
	     affl_tag = urlParams.get('affil'),
         src = urlParams.get('src'),
         override = urlParams.get('override');

    // Set affiliate tag = use default if one is not submitted
    if( affl_tag == null ){
      affl_tag = affil_tag();
    }	

    
    // If no parameter is set, use default attribution tag
    if( attr_tag == null ){
      attr_tag = default_attr[tool_pdp]; 
    }

    // If there is a local override, use that, but parameters override locals
    if( local_override != null ){
      attr_tag = local_override;
    }

    // If source is provided, use that attribution tag
    if( src == "blog" || src == "blog-epb" || src == "topcta" || src == "google_shopping" ){
      attr_tag = default_attr[src];
    }

    // If override is provided, has the highest priority
    if( override != null ){
      attr_tag = override;
    }

    /////////////
	// end of the url that contains attribution and affiliate tags
	var url_append = attr_tag + "&ref_=aa_maas&tag=" + affl_tag;

    // Main PDP links
    var main_collection = document.getElementsByClassName("amazon_link");
	var url	= tool_urls[tool_pdp] + url_append;
    
    for (let i = 0, len = main_collection.length; i < len; i++) {
      apply_url(main_collection[i],url);
    }
	
	// Comparison product links
	// For this to work, the <anchor> tag must contain a new class - plus a new field containing the tool-maps above
	// IE: class="amazon_link_sub" data="tool-5110"
	var sub_collection = document.getElementsByClassName("amazon_link_sub"); 
	
	for (let i = 0, len = sub_collection.length; i < len; i++){
	  var sub_tool_type = sub_collection[i].getAttribute('data');  // Get the tool type
	  var url = tool_urls[sub_tool_type] + url_append;		  // create the url
	  apply_url(sub_collection[i],url);
	}
  }

  //////////////////////////////////////////////////////////////
  // This allows one to change url without worrying about the specifics of the element
  //////////////////////////////////////////////////////////////
  function apply_url(element,final_url){
      // Look for Image elements
      if( element.nodeName == "IMG" ){
        element.setAttribute("data-href",final_url );
      }
      // Look for Text titles
      else if( element.nodeName == "H3" ){
        element.firstElementChild.href = final_url;
      }
      // Look for urls created from text using pagefly editor (they are <p><href></href></p>)
      else if( element.nodeName == "P" ){
        element.firstElementChild.href = final_url;
      }
      // These are basic ahrefs from Buttons and Comparison charts
      else{
        element.href = final_url;
      }  
  }

//////////////////////////////////////////////////////////////
// QUIZ TYPE Functions
//////////////////////////////////////////////////////////////

  /////////////////////////
  // Adds pagetype to quiz-cta
  // Purpose:
  //     If a typeform test is running, uses quiz ctas be part of that test
  //     Otherwise, use the default attribution for this page on this typeform
  // Params:
  //      pagetype comes from the keys of default_attribution() above
  /////////////////////////
  function add_pagetype_to_quiz_cta(pagetype){
    var tf_button = document.getElementById('tf');

    if( pagetype in default_attribution() == false ){
      console.log("ERROR: Pagetype misspelling: " + pagetype);
    }
    
    apply_url(tf_button,tf_button.href+'&type='+pagetype);
  }


  /////////////////////////
  // Typeform Function: For typeforms that go to the typeform landing page
  // Allows us to use attributions
  // To use: input an id of 'tf' to the button that goes to the typeform landing page
  // Use case 1: 
  //     I want to run a page test, the page contains a typeform
  //     I want that typeform to use same attribution as the page, because quizzes on that page are part of the conversion tracking 
  /////////////////////////
  function typeform_lp(url_tag_override = 'tag', attr_override = null){
    const urlParams = new URLSearchParams(window.location.search);
    var url_attr = urlParams.get(url_tag_override);
    var apply_attr = null;    

    // If we want more traffic to our typeform tests, change to true
    let enforce_test = false;

    if( attr_override != null ){
      apply_attr = attr_override;
    }
    else if( url_attr != null ){
      apply_attr = url_attr;
    }
    else{
      return;
    }

    var typeform = document.getElementById('tf');
    
    // If we're enforcing testing on quiz_ctas for our typeform - this makes makes it so they all go to test
    if(enforce_test){
      apply_url(typeform,'/pages/obd2-tool-finder-5?tag=test');
    }
    // Otherwise with no enforcement, let it go to the attribution
    else{
      apply_url(typeform,'/pages/obd2-tool-finder-5?form=default&tag='+apply_attr);
    }
  }

  // Typeform Function: For typeforms on same page
  // quiz_cta('attribution_tag') or https://www.innova.com/pages/shop?shop=xxxx&tf=xxxx
  function quiz_cta(local_override = null){
    const urlParams = new URLSearchParams(window.location.search);

    var tf_attr = urlParams.get('tf');
    var apply_attr = null;

    if( local_override != null ){
      apply_attr = local_override;
    }
    else if( tf_attr != null ){
      apply_attr = tf_attr;
    }
    else{
      apply_attr = get_default_attr("cta_quiz_regular");
    }
    var typeform = document.getElementById('typeform');
    typeform.setAttribute("data-tf-hidden","tag="+apply_attr);
  }